<template>
    <div class="no-bg mt-5 pt-5  white--text custom-nav">
        <ul v-for="(item, i) in items" :key="i">
            <li class="no-style-type">
                <router-link :to="item.page" class="router-link left-nav">
                    <v-icon v-if="!item.img" class="pt-1 pr-1 ml-3 white--text " v-html="item.icon"></v-icon>
                    <img v-else :src="item.img" :alt="item.title" class="pt-1 pr-1 ml-3 mr-1 ">
                    <span class="white--text" :class="item.img ? 'pb-2' : ''" @click="toggleNav()">{{item.title}}</span>
                </router-link>
                <ul class="ml-3">
                    <router-link :to="subItem.page" v-for="(subItem, s) in item.items" :key="s"
                                 class="router-link left-nav">
                        <li>
                            <v-icon class="py-1 pr-1 ml-3 white--text" v-html="subItem.icon"></v-icon>
                            <span>{{subItem.title}}</span>
                        </li>
                    </router-link>
                </ul>
            </li>
        </ul>
        <li @click="scrollTopImpressum()" id="impressum-link">Impressum</li>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'router-links-list',
        computed: {
            ...mapGetters(['isMobile'])
        },
        data() {
            return {
                items: [
                    {
                        img: '/static/tec-logo-white.svg',
                        title: 'Home',
                        page: '/',
                        items: []
                    },
                    {
                        icon: '💎',
                        title: 'Verein',
                        page: '/club',
                        items: [{
                            icon: 'import_contacts',
                            title: 'Allgemeines',
                            page: '/club',
                        },
                            {
                                icon: 'gesture',
                                title: 'Training',
                                page: '/club/training/Eiskunstlauf-0',
                            },
                            {
                                icon: 'people',
                                title: 'Trainer',
                                page: '/club/coach',
                            },
                            {
                                icon: 'people_outline',
                                title: 'Übungsleiter',
                                page: '/club/instructor',
                            },
                            {
                                icon: '⛸️',
                                title: 'Sportler',
                                page: '/club/athlete',
                            },

                            {
                                icon: '🗃️',
                                title: 'Vorstand',
                                page: '/club/directorate',
                            },
                            {
                                icon: '🏆',
                                title: 'Veranstaltungen',
                                page: '/club/competitions'
                            }
                        ]
                    },
                    {
                        icon: 'access_time', // insert_drive_file
                        title: 'Trainingsplan',
                        short: 'Plan',
                        page: '/schedule',
                    }, {
                        icon: 'photo_library',
                        title: 'Media Gallery',
                        short: 'Media',
                        page: '/gal',
                    },
                    {
                        icon: 'contact_support',
                        title: 'Kontakt',
                        page: '/club/training/Kontakt-5',
                    },
                ]
            }
        },
        methods: {
            scrollTopImpressum() {
                //document.getElementById('impressum').scrollTop = 0


                setTimeout(() => {
                    this.$vuetify.goTo('#impressum', {offset: 0, duration: 300, easing: 'easeOutCubic'})
                }, 100)
                if (this.isMobile) {
                    this.$emit('closeMe')
                    if (ga) {
                        ga('send', {
                            hitType: 'event',
                            eventCategory: 'impressum_click_mobile',
                            eventAction: 'navigate',
                            eventLabel: "#impressum",
                            eventValue: 1
                        });
                    }
                } else {
                    if (ga) {
                        ga('send', {
                            hitType: 'event',
                            eventCategory: 'impressum_click_desktop',
                            eventAction: 'navigate',
                            eventLabel: "#impressum",
                            eventValue: 1
                        });

                    }
                }
                // console.log(document.getElementsByTagName('html')[0])
            },
            toggleNav() {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
                if (this.$route.path === '/' && this.isMobile) {
                    this.$emit('closeMe')
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'same_page_home_route_mobile',
                        eventAction: 'toggle_left_nav',
                        eventLabel: "leftNav"
                    });
                } else if (this.isMobile) {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: this.$route.path + '_mobile',
                        eventAction: 'toggle_left_nav',
                        eventLabel: "leftNav"
                    });
                } else {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: this.$route.path + '_desktop',
                        eventAction: 'toggle_left_nav',
                        eventLabel: "leftNav"
                    });
                }
            }
        }
    }
</script>
<style>
    #impressum-link {
        padding-left: 40px;
        padding-top: 0;
        list-style-type: none;
        cursor: pointer;
    }

    #impressum-link:before {
        content: '🗒️';
        font-size: 150%;
        padding-right: 10px;
    }

    .router-link.left-nav li, .router-link.left-nav li i {
        color: white;
        text-decoration: none;
        list-style-type: none;
    }

    .no-style-type {
        list-style-type: none;
    }

    .custom-nav > ul > li > a {

        border-radius: 3px;
        padding-right: 8px;
        display: inline-block;
        margin-bottom: 15px;
    }

    .custom-nav > ul:nth-child(3) {
        margin-top: 15px;
    }

    .custom-nav a.router-link:not(.router-link-exact-active):hover, #impressum-link:hover {
        text-shadow: #00f3ff 1px 1px 10px;
        box-shadow: unset;
    }
</style>
